<template>
    <app-chip :type="colour" :text="$t(`enums.remote_application_status.${status}`)" :large="large" />
</template>

<script>
import { RemoteApplication } from '@/models';
import RemoteApplicationStatusEnum from '@/enums/remoteApplication/status';

export default {
    name: 'RemoteApplicationStatus',
    props: {
        remoteApplication: {
            type: RemoteApplication,
            required: true
        },
        large: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        status() {
            return this.remoteApplication.status || RemoteApplicationStatusEnum.DRAFT;
        },
        colour() {
            if (this.status === RemoteApplicationStatusEnum.REJECTED) {
                return 'error';
            } else if (this.status === RemoteApplicationStatusEnum.ACCEPTED) {
                return 'success';
            } else if (this.status === RemoteApplicationStatusEnum.SENT) {
                return 'info';
            } else if (this.status === RemoteApplicationStatusEnum.DRAFT) {
                return null;
            }

            return 'primary';
        }
    }
};
</script>
